// Tarif in der Kopfzeile (Platz von „Zur Buchhaltung“): „Kostenlos · 3/5“ (Rechnungen diesen Monat), „Pro-Test · noch
// 9 Tage“, „Start“. Führt zu /rechnung/tarif. Ohne Tarif (Kanzlei oder Übersicht noch nicht geladen) nichts.
import { Link } from 'react-router-dom';
import { nochTage } from './anzeige';
import type { Tarif } from './types';
import { planName } from './upgrade';
import './hinweise.css';

export function PlanBadge({ tarif }: { tarif: Tarif | null | undefined }) {
  if (!tarif) return null;
  const name = planName(tarif, tarif.effektiv);
  const limit = tarif.grenzen.rechnungenMonat;
  const offen = tarif.status === 'ueberfaellig';
  let inhalt;
  if (tarif.testAktiv && tarif.testBis) {
    inhalt = (
      <>
        {name}-Test · {nochTage(tarif.testBis)}
      </>
    );
  } else if (limit !== null) {
    inhalt = (
      <>
        {name} · {Math.min(tarif.nutzung.rechnungenMonat, limit)}/{limit}
        <span className="sr-only"> Rechnungen diesen Monat</span>
      </>
    );
  } else {
    inhalt = (
      <>
        {name}
        {offen && <span className="sr-only">, Zahlung offen</span>}
      </>
    );
  }
  return (
    <Link to="/rechnung/tarif" className={`rt-app bt-plan${offen ? ' bt-plan-offen' : ''}`}>
      <span className="sr-only">Tarif: </span>
      {inhalt}
    </Link>
  );
}
